import DocumentsTable from "@mirage/components/documentsTable/DocumentsTable";
import React, { useCallback, useMemo } from "react";
import { GridColDef } from "@mui/x-data-grid-premium";
import useSessionStorage from "@mirage/hooks/useSessionStorage";
import { PPConstants } from "@shared/publicportal/constants";

const BrDocumentsTabContent: React.FC<{ appId?: number }> = ({ appId }) => {
    const displayFor = useMemo(() => ({ entityRecord: { entityName: "BC_APPLICATION", recordId: Number(appId || -1) } }), [appId]);
    const [sessionValue] = useSessionStorage(PPConstants.AppName);
    const visibleDocumentsTableColumns = sessionValue.clientSettings.DOCUMENTS_TABLE_COLUMNS;
    const overrideColumns = useCallback(
        (existingColumns: GridColDef[]) => {
            if (!Array.isArray(visibleDocumentsTableColumns) || visibleDocumentsTableColumns.length == 0) {
                return existingColumns;
            }
            const alwaysVisibleColumns = ["action", "folder"];
            return existingColumns.filter((col) => visibleDocumentsTableColumns.find((visibleCol) => visibleCol == col.field || alwaysVisibleColumns.includes(col.field)));
        },
        [visibleDocumentsTableColumns]
    );

    return <DocumentsTable publicOnly={true} readOnly={true} stateKey="bc-application-documents" displayFor={displayFor} overrideColumns={overrideColumns} />;
};

export default BrDocumentsTabContent;
